var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgName2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  }))), /*#__PURE__*/React.createElement("g", {
    id: "joe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.47,162q4.41,3.34,13.54,6.57a64.88,64.88,0,0,0,21.57,3.22q12.17,0,19.77-4A26.62,26.62,0,0,0,74,155.55q4-8.18,5.53-20.92A259.9,259.9,0,0,0,81,104.44V0h31.25V100.14a316.43,316.43,0,0,1-2.36,40.22q-2.34,18.3-9.26,31.76a47.4,47.4,0,0,1-20.6,20.67Q66.37,200,43.41,200a85.71,85.71,0,0,1-24-3.08A66,66,0,0,1,0,187.69Z",
    style: {
      fill: "#aaa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.13,200Q216,200,199,191.67A91.74,91.74,0,0,1,169.58,169,105.6,105.6,0,0,1,150.5,136.8a103.71,103.71,0,0,1-6.73-36.8,100.72,100.72,0,0,1,7.14-37.64,105.93,105.93,0,0,1,19.77-31.94A94.61,94.61,0,0,1,200.47,8.19,85.29,85.29,0,0,1,237.68,0a83.6,83.6,0,0,1,38,8.61,92.17,92.17,0,0,1,29.38,23.06,109.61,109.61,0,0,1,19,32.22,103.23,103.23,0,0,1-.27,74,103.82,103.82,0,0,1-19.64,31.94,92.53,92.53,0,0,1-29.79,22.08A86.34,86.34,0,0,1,237.13,200ZM175.07,100a83.85,83.85,0,0,0,4.4,26.94A75,75,0,0,0,192,150.14a58.93,58.93,0,0,0,19.63,16,56.39,56.39,0,0,0,25.82,5.83,55.39,55.39,0,0,0,26.36-6.11,57.73,57.73,0,0,0,19.36-16.52A78.08,78.08,0,0,0,295.07,126a85.2,85.2,0,0,0-.14-52.78,71.94,71.94,0,0,0-12.49-23,60.77,60.77,0,0,0-19.63-16,59,59,0,0,0-51.76.27,59.91,59.91,0,0,0-19.5,16.39,77.25,77.25,0,0,0-12.22,23.06A82,82,0,0,0,175.07,100Z",
    style: {
      fill: "#aaa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,172.11V200H364.39V0h133.1V27.89H395.58v56.9h88.27V111H395.58v61.12Z",
    style: {
      fill: "#aaa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "han"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144,.14v200h-27.9V112H27.66v88.17H0V.14H27.66V83.79h88.39V.14Z",
    style: {
      fill: "#aaa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08.14h26.17l68.15,200H299.26l-17.13-54.38H212l-17.21,54.38H165.43ZM274.77,122.4l-27.6-87.62L219.43,122.4Z",
    style: {
      fill: "#aaa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.78,58.71V200.14H350.12V.14h22.71l99.27,144.5V.41H500V200.14H475.8Z",
    style: {
      fill: "#aaa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "center"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.16,221.62a23.69,23.69,0,0,0,6.47,3,30.66,30.66,0,0,0,9.26,1.28,20.62,20.62,0,0,0,9.79-2,13.33,13.33,0,0,0,5.71-6.12,32,32,0,0,0,2.68-10.22,127,127,0,0,0,.7-14.32V150h8.16v41.72a140.19,140.19,0,0,1-.93,16.87,42,42,0,0,1-3.62,13.17,19.12,19.12,0,0,1-8,8.55q-5.35,3-14.21,3A36.68,36.68,0,0,1,147,232a28.18,28.18,0,0,1-8.16-3.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,233.27a35.43,35.43,0,0,1-15.85-3.5,38,38,0,0,1-12.24-9.49,45,45,0,0,1-10.72-29,43.55,43.55,0,0,1,11.13-29.19,40.08,40.08,0,0,1,12.41-9.33,34.91,34.91,0,0,1,15.39-3.43A34.44,34.44,0,0,1,264,153a38.39,38.39,0,0,1,12.18,9.67A46.35,46.35,0,0,1,284,176.17a43.74,43.74,0,0,1-8.28,44.45,38.35,38.35,0,0,1-12.35,9.27A35.42,35.42,0,0,1,248,233.27Zm-30.65-42a38.66,38.66,0,0,0,2.21,13,35.34,35.34,0,0,0,6.3,11.07,30.57,30.57,0,0,0,9.73,7.69,28.63,28.63,0,0,0,25.17-.11,30.91,30.91,0,0,0,9.67-7.93,35.74,35.74,0,0,0,6.12-11.13,38.79,38.79,0,0,0,2.1-12.58,38,38,0,0,0-2.22-12.94,35.5,35.5,0,0,0-6.35-11.07,30.62,30.62,0,0,0-9.73-7.69,28.75,28.75,0,0,0-25,.12,30.13,30.13,0,0,0-9.67,7.86,36.72,36.72,0,0,0-6.17,11.13A37.92,37.92,0,0,0,217.37,191.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.17,225.46v7.23H305.59V150h54.53v7.22H313.74V187h40.44v6.87H313.74v31.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.09,267.9v82.73h-8V312H147v38.68h-8.16V267.9H147v36.82h49.06V267.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.64,267.9h6.87l34.38,82.73h-8.62l-10.34-25.87H229.11l-10.34,25.87H210Zm19.73,50.45L248,277.45l-16.35,40.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.11,282.93v67.7H292V267.9h6.76l54.3,69V268h8.16v82.62H353.6Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgName2);
export default __webpack_public_path__ + "static/media/name2.805cbad81cf93b53c05164d664d93a99.svg";
export { ForwardRef as ReactComponent };